// Where the backend API lives, resolved from the page's hostname — the same
// bundle works in every topology without a hardcoded override:
//
//   app.patensys.com / prod        → /api (same origin; ingress maps it)
//   dev.patensys.com               → /api (same origin; ingress maps it)
//   localhost:8080                 → http://localhost:3000 (local backend)
//   app.patensys-dev.com           → https://api.patensys-dev.com
//                                    (named tunnel: app host = frontend,
//                                     api host = backend; routes mount BARE
//                                     there — no /api prefix exists locally)
//   *.trycloudflare.com (quick)    → same-host (quick-tunnel sessions set
//                                    API_BASE_OVERRIDE below instead — the
//                                     two tunnel hosts rotate independently)
//
// API_BASE_OVERRIDE is the escape hatch for quick-tunnel sessions: paste the
// backend's current tunnel URL, leave it "" otherwise. Never commit a live
// value (the convention from requests.js since tunnels existed).
const API_BASE_OVERRIDE = "";

export function apiBase() {
  if (API_BASE_OVERRIDE) return API_BASE_OVERRIDE;
  const host = location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "http://localhost:3000";
  if (host.endsWith(".patensys-dev.com")) return "https://api.patensys-dev.com";
  return "/api";
}

// Where the MCP connector's OAuth endpoints live. The connector is mounted on
// its OWN origin (no /api prefix — the OAuth issuer must be an origin), which
// differs from the app API host on the deployed topologies:
//
//   dev.patensys.com   → https://api.dev.patensys.com   (connector subdomain)
//   app.patensys.com   → https://api.app.patensys.com   (prod connector subdomain)
//   localhost          → http://localhost:3000          (local backend, bare)
//   *.patensys-dev.com → https://api.patensys-dev.com   (named tunnel, bare)
//
// Used by the OAuth consent page (its /oauth/consent/* + /oauth/authorize/confirm
// calls go to the connector, NOT to apiBase()).
export function connectorBase() {
  const host = location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "http://localhost:3000";
  if (host.endsWith(".patensys-dev.com")) return "https://api.patensys-dev.com";
  if (host === "dev.patensys.com") return "https://api.dev.patensys.com";
  if (host === "app.patensys.com") return "https://api.app.patensys.com";
  return "https://api.patensys.com";
}
